import { render, staticRenderFns } from "./KycSearchResults.vue?vue&type=template&id=f4131034&"
import script from "./KycSearchResults.vue?vue&type=script&lang=js&"
export * from "./KycSearchResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports